import type { ReactNode } from 'react';

export const symbol_arrow_and_edge: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-235v-225q0-24.75-17.62-42.38Q414.75-520 390-520H100q-24.75 0-42.37-17.63Q40-555.25 40-580v-230q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v230h290q26.82 0 49.91 11Q463-558 480-539q17-19 40.09-30 23.09-11 49.91-11h290v-230q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v230q0 24.75-17.62 42.37Q884.75-520 860-520H570q-24.75 0-42.37 17.62Q510-484.75 510-460v225l53-52q9-8 21-8.5t21 8.11q9 9.39 9 21.49 0 12.1-9 20.9L501-141q-9 9-21 9t-21-9L355-245q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l52 52Z"
		/>
	</svg>
);
